import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AppStore } from '../../../../app.store';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { AVAILABLE_LANGUAGES } from '../../../../core/constants';
import { TranslatePipe } from '../../../../shared/pipes/translationPipe';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-theme-language-selector',
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    MatOptionModule,
    TranslatePipe,
AsyncPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './theme-language-selector.component.html',
  styleUrls: ['./theme-language-selector.component.scss'],
})
export class ThemeLanguageSelectorComponent {
  readonly store = inject(AppStore);
  readonly availableLanguages = AVAILABLE_LANGUAGES;
}
